import { render } from "./NavigationMain.vue?vue&type=template&id=636cd2a2"
import script from "./NavigationMain.vue?vue&type=script&lang=js"
export * from "./NavigationMain.vue?vue&type=script&lang=js"

import "./NavigationMain.vue?vue&type=style&index=0&id=636cd2a2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__